'use client'

import { TransparencyLaw } from '@marketplace-web/user-agreements/legal-block-feature'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { ItemPageTransparencyLawPluginModel } from './types'

type Props = {
  data?: ItemPageTransparencyLawPluginModel
}

const ItemPageTransparencyLawPlugin = ({ data }: Props) => {
  const rightOfWithdrawalInItemPageAbTest = useAbTest('right_of_withdrawal_in_item_page')
  const rightOfWithdrawalCombinedChangesAbTest = useAbTest('right_of_withdrawal_combined_changes')

  useTrackAbTest(rightOfWithdrawalInItemPageAbTest, data && !data.isBusiness)
  useTrackAbTest(rightOfWithdrawalCombinedChangesAbTest, data && !data.isBusiness)

  if (!data) return null
  if (data.isBusiness) return null

  return (
    <TransparencyLaw
      subject={
        rightOfWithdrawalInItemPageAbTest?.variant === 'on' ||
        rightOfWithdrawalCombinedChangesAbTest?.variant === 'on'
          ? TransparencyLaw.TransparencyLawSubject.RightOfWithdrawal
          : TransparencyLaw.TransparencyLawSubject.BuyerRights
      }
    />
  )
}

export default ItemPageTransparencyLawPlugin
